// extracted by mini-css-extract-plugin
export default {"cardSection":"ContactCard_cardSection__ilO3-"};